import { useMemo } from "react"
import { AvailabilityStatus } from "@tm/models"
import { RimSorting } from "@bundles/wheels/components/_shared/RimSortDropdown"
import { AvailabilityFilterType } from "../../../../business"
import { RimItem } from "../../../../data/model"

export const useFilteredRimList = (
    data: RimItem[],
    availability: AvailabilityFilterType,
    availabilityStatusIdsToShow?: AvailabilityStatus[],
    availabilityStatusIdsToShowSecondary?: AvailabilityStatus[],
    sort?: RimSorting,
    showPurchasePrice?: boolean
): RimItem[] => {
    return useMemo(() => {
        const filterAvailabilities = (rim: RimItem) => {
            const availabilities =
                rim.rimErpInformations?.filter((info) => {
                    if (availability === AvailabilityFilterType.Primary && availabilityStatusIdsToShow?.length) {
                        return availabilityStatusIdsToShow.includes(info.availability?.type!)
                    }
                    if (availability === AvailabilityFilterType.Secondary && availabilityStatusIdsToShowSecondary?.length) {
                        return availabilityStatusIdsToShowSecondary.includes(info.availability?.type!)
                    }
                    return false
                }) || []

            const availableDiameterSizes = rim.sizeInfo.filter((sizeInfo) =>
                availabilities.some((item) => item.diameterSize === sizeInfo.size.toString())
            )

            return {
                ...rim,
                rimErpInformations: availabilities,
                availableDiameterSizes,
            }
        }

        const rims = availability ? data.map(filterAvailabilities).filter((item) => item.rimErpInformations.length > 0) : [...data]

        if (sort === "price" || sort === "priceDescending") {
            const getMinPrice = (rim: RimItem): number => {
                const allPrices = rim.rimErpInformations
                    .flatMap((info) => info?.prices)
                    // depending on showPurchasePrice in userSettings, we want to show either purchase price or sale price
                    .filter((price) => (showPurchasePrice ? price?.type === 4 : price?.type === 5))
                    .map((price) => price.value)

                return allPrices.length > 0 ? Math.min(...allPrices) : Number.MAX_SAFE_INTEGER
            }

            return [...rims].sort((a, b) => {
                const diff = getMinPrice(a) - getMinPrice(b)
                return sort === "price" ? diff : -diff
            })
        }

        return rims
    }, [data, availability, availabilityStatusIdsToShow, availabilityStatusIdsToShowSecondary, sort, showPurchasePrice])
}
